var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"generated-report-list"},[_c('GeneratedReportsList',{attrs:{"reports":_vm.getUserGeneratedReports},on:{"refresh":_vm.refresh}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }